import {
    SET_SCHOOL_APPOINTMENT_ID,
    SET_SCHOOL_DATE,
    SET_SCHOOL_TIME,
    SET_SCHOOL_SESSIONS_PER_WEEK,
    SET_SCHOOL_SESSION_TYPE,
    SET_SCHOOL_REPEAT,
    SET_SCHOOL_SUBJECT_ID,
    SET_SCHOOL_APPOINTMENT_TYPE,
    SET_SCHOOL_JOB_VALUE,
    SET_SCHOOL_SELECTED_STUDENT,
    SCHOOL_RESET_APPOINTMENT_STATE,
    SET_SCHOOL_DURATION
  } from '../actions/schoolPresetValuesTypes';
  
  // Initial state for school preset values
  const initialState = {
    schoolAppointmentId: null,
    schoolDate: null,
    schoolTime: null,
    schoolSessionsPerWeek: '',
    schoolSessionType: '',
    schoolRepeat: '',
    schoolSubjectId: null,
    schoolAppointmentType: '',
    schoolJobValue: '',
    schoolSelectedStudent: null,
    schoolDuration: null,
  };
  
  // Reducer function to handle school preset value actions
  const schoolPresetValuesReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_SCHOOL_APPOINTMENT_ID:
        return { ...state, schoolAppointmentId: action.payload };
      case SET_SCHOOL_DATE:
        return { ...state, schoolDate: action.payload };
      case SET_SCHOOL_TIME:
        return { ...state, schoolTime: action.payload };
      case SET_SCHOOL_SESSIONS_PER_WEEK:
        return { ...state, schoolSessionsPerWeek: action.payload };
      case SET_SCHOOL_SESSION_TYPE:
        return { ...state, schoolSessionType: action.payload };
      case SET_SCHOOL_REPEAT:
        return { ...state, schoolRepeat: action.payload };
      case SET_SCHOOL_SUBJECT_ID:
        return { ...state, schoolSubjectId: action.payload };
      case SET_SCHOOL_APPOINTMENT_TYPE:
        return { ...state, schoolAppointmentType: action.payload };
      case SET_SCHOOL_JOB_VALUE:
        return { ...state, schoolJobValue: action.payload };
        case SET_SCHOOL_SELECTED_STUDENT:
        return { ...state, schoolSelectedStudent: action.payload };
        case SET_SCHOOL_DURATION: 
      return { ...state, schoolDuration: action.payload };
       case SCHOOL_RESET_APPOINTMENT_STATE:
      return initialState;

      default:
        return state;
    }
  };
  
  export default schoolPresetValuesReducer;
  